module.exports = __webpack_public_path__ + "static/img/icon2.b2bc2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon2.png
// module id = HosE
// module chunks = 4